import { atom } from "recoil";
import { ModalConfig } from "../Types/Modals";

export const modalsAtom = atom<ModalConfig[]>({
    key: "modals",
    default: [],
    dangerouslyAllowMutability: true
})